module.exports = __webpack_public_path__ + "static/media/b74acd489a754d949d24a279bc1a44e6.001a294e.jpg";